import {
  BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE,
  BRAND_AFFINITY_LEVEL_COLORS,
} from 'ui/brandAffinityIndicator/constants';
import { BrandAffinityLevel, getScoreDataByLevel } from 'modules/domains/brandAffinity';

export const getScoreUIDataByLevel = (level: BrandAffinityLevel) => ({
  ...getScoreDataByLevel(level),
  percent:
    BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE[level] ||
    BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE[BrandAffinityLevel.UNSCORED],
  color:
    BRAND_AFFINITY_LEVEL_COLORS[level] || BRAND_AFFINITY_LEVEL_COLORS[BrandAffinityLevel.UNSCORED],
});

export const createAnalyticsLink = (id: number | string) =>
  `/analytics/campaignPerformance?campaignId=${id}`;
